export const FETCH_TIMESHEET_MANAGER_INBOX_REQUEST = "FETCH_TIMESHEET_MANAGER_INBOX_REQUEST";
export const FETCH_TIMESHEET_MANAGER_INBOX_SUCCESS = "FETCH_TIMESHEET_MANAGER_INBOX_SUCCESS";
export const FETCH_TIMESHEET_MANAGER_INBOX_FAIL    = "FETCH_TIMESHEET_MANAGER_INBOX_FAIL";

export const FETCH_TIMESHEET_ADMIN_INBOX_REQUEST   = "FETCH_TIMESHEET_ADMIN_INBOX_REQUEST";
export const FETCH_TIMESHEET_ADMIN_INBOX_SUCCESS   = "FETCH_TIMESHEET_ADMIN_INBOX_SUCCESS";
export const FETCH_TIMESHEET_ADMIN_INBOX_FAIL      = "FETCH_TIMESHEET_ADMIN_INBOX_FAIL";

export const TIMESHEET_MANAGER_DECISION_REQUEST    = "TIMESHEET_MANAGER_DECISION_REQUEST";
export const TIMESHEET_MANAGER_DECISION_SUCCESS    = "TIMESHEET_MANAGER_DECISION_SUCCESS";
export const TIMESHEET_MANAGER_DECISION_FAIL       = "TIMESHEET_MANAGER_DECISION_FAIL";

export const TIMESHEET_ADMIN_DECISION_REQUEST      = "TIMESHEET_ADMIN_DECISION_REQUEST";
export const TIMESHEET_ADMIN_DECISION_SUCCESS      = "TIMESHEET_ADMIN_DECISION_SUCCESS";
export const TIMESHEET_ADMIN_DECISION_FAIL         = "TIMESHEET_ADMIN_DECISION_FAIL";

export const FETCH_TIMESHEET_MANAGER_HISTORY_REQUEST = "FETCH_TIMESHEET_MANAGER_HISTORY_REQUEST";
export const FETCH_TIMESHEET_MANAGER_HISTORY_SUCCESS = "FETCH_TIMESHEET_MANAGER_HISTORY_SUCCESS";
export const FETCH_TIMESHEET_MANAGER_HISTORY_FAIL    = "FETCH_TIMESHEET_MANAGER_HISTORY_FAIL";

export const FETCH_TIMESHEET_ADMIN_HISTORY_REQUEST   = "FETCH_TIMESHEET_ADMIN_HISTORY_REQUEST";
export const FETCH_TIMESHEET_ADMIN_HISTORY_SUCCESS   = "FETCH_TIMESHEET_ADMIN_HISTORY_SUCCESS";
export const FETCH_TIMESHEET_ADMIN_HISTORY_FAIL      = "FETCH_TIMESHEET_ADMIN_HISTORY_FAIL";

export const fetchManagerInboxRequest = (meta = {}) => ({ type: FETCH_TIMESHEET_MANAGER_INBOX_REQUEST, meta });
export const fetchManagerInboxSuccess = (data) => ({ type: FETCH_TIMESHEET_MANAGER_INBOX_SUCCESS, payload: data });
export const fetchManagerInboxFail    = (err)  => ({ type: FETCH_TIMESHEET_MANAGER_INBOX_FAIL,    payload: err  });

export const fetchAdminInboxRequest   = (meta = {}) => ({ type: FETCH_TIMESHEET_ADMIN_INBOX_REQUEST, meta });
export const fetchAdminInboxSuccess   = (data) => ({ type: FETCH_TIMESHEET_ADMIN_INBOX_SUCCESS, payload: data });
export const fetchAdminInboxFail      = (err)  => ({ type: FETCH_TIMESHEET_ADMIN_INBOX_FAIL,    payload: err  });

export const fetchManagerHistoryRequest = (meta = {}) => ({ type: FETCH_TIMESHEET_MANAGER_HISTORY_REQUEST, meta });
export const fetchManagerHistorySuccess = (data) => ({ type: FETCH_TIMESHEET_MANAGER_HISTORY_SUCCESS, payload: data });
export const fetchManagerHistoryFail    = (err)  => ({ type: FETCH_TIMESHEET_MANAGER_HISTORY_FAIL,    payload: err  });

export const fetchAdminHistoryRequest   = (meta = {}) => ({ type: FETCH_TIMESHEET_ADMIN_HISTORY_REQUEST, meta });
export const fetchAdminHistorySuccess   = (data) => ({ type: FETCH_TIMESHEET_ADMIN_HISTORY_SUCCESS, payload: data });
export const fetchAdminHistoryFail      = (err)  => ({ type: FETCH_TIMESHEET_ADMIN_HISTORY_FAIL,    payload: err  });

export const managerDecisionRequest   = (payload) => ({ type: TIMESHEET_MANAGER_DECISION_REQUEST, payload });
export const managerDecisionSuccess   = (data)    => ({ type: TIMESHEET_MANAGER_DECISION_SUCCESS, payload: data });
export const managerDecisionFail      = (err)     => ({ type: TIMESHEET_MANAGER_DECISION_FAIL,    payload: err  });

export const adminDecisionRequest     = (payload) => ({ type: TIMESHEET_ADMIN_DECISION_REQUEST, payload });
export const adminDecisionSuccess     = (data)    => ({ type: TIMESHEET_ADMIN_DECISION_SUCCESS, payload: data });
export const adminDecisionFail        = (err)     => ({ type: TIMESHEET_ADMIN_DECISION_FAIL,    payload: err  });
